import React, { useEffect } from "react";

import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";
import { useNewGlobalSearchService } from "pages/[tenant]/search/hooks/useNewGlobalSearchService/useNewGlobalSearchService";

import { XIcon } from "shared/assets/icons/XIcon";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";
import { CheckIcon } from "@Console/sales/assets/icons/CheckIcon";

import AuthorsSection from "../../molecules/AuthorsSection";
import TagsSection from "../../molecules/TagsSection";
import { FilterModalContainer, FiltersSection, Overlay } from "./styles";

const FilterModal = () => {
  const {
    handleChangeModal,
    tagsList,
    filterByAuthors,
    filterByTags,
    selectedTags,
    setSelectedAuthors,
    selectedAuthors,
    setSelectedTags,
    setIsFiltering,
  } = useNewGlobalSearch();

  const { getTags } = useNewGlobalSearchService();

  useEffect(() => {
    if (tagsList?.length <= 0) getTags();
  }, []);

  const handleApplyFilters = () => {
    if (selectedAuthors?.length > 0) filterByAuthors();
    if (selectedTags?.length > 0) filterByTags();
    setIsFiltering(true);
    handleChangeModal();
  };

  const handleCancelModal = () => {
    setSelectedAuthors([]);
    setSelectedTags([]);
    handleChangeModal();
  };

  return (
    <>
      <FilterModalContainer>
        <div className="top-section">
          <h3>Filtrar pesquisa</h3>
          <div className="close-icon" onClick={handleCancelModal} role="button">
            <XIcon />
          </div>
        </div>

        <FiltersSection>
          <AuthorsSection />
          <div className="tag-section">
            {tagsList?.map((tag) => (
              <TagsSection category={tag} key={tag?.id} />
            ))}
          </div>
        </FiltersSection>

        <div className="buttons-section">
          <ConsolePageForm.Button
            variant="secondary"
            onClick={handleCancelModal}
            id="close-modal-button"
          >
            Cancelar
          </ConsolePageForm.Button>

          <ConsolePageForm.Button
            variant="primary"
            onClick={() => handleApplyFilters()}
            id="new-link-button"
          >
            <CheckIcon /> Adicionar
          </ConsolePageForm.Button>
        </div>
      </FilterModalContainer>
      <Overlay onClick={handleCancelModal} />
    </>
  );
};

export default FilterModal;
